import { css, keyframes } from "styled-components";
import token from "styled-token";
import { animationA11yMixin } from "./animationA11yMixin";
var zoomInKeyframes = /*#__PURE__*/keyframes(["from{transform:scale(0);}to{transform:scale(1);}"]);
/** @mixin animationZoomInMixin */

/**
 * Adds a zoom in animation to a component that meets a11y standards.
 *
 * @example
 * import { animationZoomInMixin } from '@zillow/constellation';
 *
 * const Component = styled.div`
 *     ${animationZoomInMixin}
 * `;
 *
 * <Component>My animated component</Component>
 *
 * @method
 * @return {CSSObject}
 */

export var animationZoomInMixin = token({
  duration: "animations.defaultDuration",
  timing: "animations.defaultTimingFunction"
}, function (tokens) {
  return animationA11yMixin(css(["animation:", " ", "s ", ";"], zoomInKeyframes, tokens.duration, tokens.timing));
});